import {
  ADD_PRODUCT,
  DECREMENT,
  INCREMENT,
  RESTORE_QUANTITY,
} from "./actionTypes";

export const addProduct = (productInfo) => {
  return {
    type: ADD_PRODUCT,
    payload: productInfo,
  };
};

export const incrementProductQuantity = (id) => {
  return {
    type: INCREMENT,
    payload: id,
  };
};

export const decrementProductQuantity = (id) => {
  return {
    type: DECREMENT,
    payload: id,
  };
};

export const restoreProductQuantity = (id, value) => {
  return {
    type: RESTORE_QUANTITY,
    payload: { id, value },
  };
};
